export default __webpack_public_path__ + "static/media/arrow-double-24px.6ec3c76c.svg";